module.exports = __webpack_public_path__ + "static/media/background.4683f636.png";